import {
	GotoCleanLabelProducts,
	GotoKehe,
	GotoMinorityProducts,
	GotoNewtoMarketProducts,
	GotoNextyProducts,
	GotoPrivateProducts
} from '../Cta/Cta';
// import { SeeAll } from '../SeeAll/SeeAll';

export const ForBigDesktops = () => {
	return (
		<div className='newtopiaLarge'>
			<div className='newtopiaLarge__cardContainer'>
				<div className='cardDesktop cardTopContainer'>
					<div className='cardPrivate'>
						<GotoPrivateProducts />
					</div>
					<div className='cardLabel'>
						<GotoCleanLabelProducts />
					</div>
					<div className='cardNexty'>
						<GotoNextyProducts />
					</div>
				</div>
				<div className='cardDesktop cardBottomContainer'>
					<div className='cardMinority'>
						<GotoMinorityProducts />
					</div>
					<div className='cardKehe'>
						<GotoKehe />
					</div>
				</div>
				<div className='cardDesktop cardLeftContainer'>
					<div className='cardNewtoMarket'>
						<GotoNewtoMarketProducts />
					</div>
				</div>
				<div className='newtopiawave'></div>
			</div>
		</div>
	);
};
